import _InputNumber from './InputNumber';

import './style/index.js';

export type { InputNumberProps } from './InputNumber';
export * from './type';

export const InputNumber = _InputNumber;
export default InputNumber;
